import React, { useState } from 'react';
import './Testimonials.css';
import Divider from '../VerticalsWePower/Divider';

const testimonialData = [
  {
    company_logo: "/images/airtablelogo.svg",
    quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    reviewer_photo: "/images/avatar.svg",
    reviewer_name: "Thiyagarajan Kumararaja",
    reviewer_title: "Founder & CEO"
  },
  {
    company_logo: "/images/airtablelogo.svg",
    quote: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    reviewer_photo: "/images/peopleicon.svg",
    reviewer_name: "Jane Doe",
    reviewer_title: "CEO, Company B"
  },
  {
    company_logo: "/images/airtablelogo.svg",
    quote: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    reviewer_photo: "/images/user.svg",
    reviewer_name: "John Smith",
    reviewer_title: "CTO, Company C"
  }
];

const Testimonials = () => {
  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);

  const handleNext = () => {
    setCurrentTestimonialIndex((prevIndex) =>
      (prevIndex + 1) % testimonialData.length
    );
  };

  const handlePrev = () => {
    setCurrentTestimonialIndex((prevIndex) =>
      (prevIndex - 1 + testimonialData.length) % testimonialData.length
    );
  };

  const currentTestimonial = testimonialData[currentTestimonialIndex];

  return (
    <>
      <Divider />
      <section className="testimonials-section">
        <div className="testimonials-container">
          <div className="wave2-bg">
            <img src="/images/wavedownward.svg" alt="" />
          </div>
          <div className="testimonials-left-content">
            <div className="testimonials-intro">
              <div className="testimonials-line"></div>
              <span className="testimonials-badge">TESTIMONIALS</span>
            </div>
            <h2 className="testimonials-title">What our client says about our technology & products</h2>
            <div className="testimonials-navigation">
              <button className="nav-button" onClick={handlePrev}>&larr;</button>
              <button className="nav-button" onClick={handleNext}>&rarr;</button>
            </div>
          </div>

          <div className="testimonial-card">
            <div className="card-header">
              <img src={currentTestimonial.company_logo} alt={`${currentTestimonial.company_name} Logo`} className="company-logo" />
              <span className="company-name">{currentTestimonial.company_name}</span>
            </div>
            <p className="testimonial-quote">
              {currentTestimonial.quote}
            </p>
            <div className="reviewer-info">
              <img src={currentTestimonial.reviewer_photo} alt="Reviewer" className="reviewer-photo" />
              <div>
                <p className="reviewer-name">{currentTestimonial.reviewer_name}</p>
                <p className="reviewer-title">{currentTestimonial.reviewer_title}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Divider />
    </>
  );
};

export default Testimonials; 